module.exports = __webpack_public_path__ + "static/media/image18.c2ad383a.png";